module.exports = __webpack_public_path__ + "static/media/avatar-testimony-2.d4f85410.png";